import React, { useEffect, useState } from "react";
import { Carousel } from "react-bootstrap";
import {
  Carousel1,
  CarouselItem,
  Button,
  HelpButton,
  CarouselItem2,
  CircleButton,
} from "./HomeWellnessContainer.styled";
import ModalConfirm from "../../components/ModalConfirm/ModalConfirm";
import Carouselimage1 from "../../assets/Carouselimage.png";
import Carouselimage2 from "../../assets/carouselimage2.png";
import { ReactComponent as Circle } from "../../assets/svg/circle.svg";
import { RESOURCE_LIST_BY_MODULE } from "../../GraphQL/Queries";
import { SEND_ICE_ALERT } from "../../GraphQL/Mutations";
import { getUserGuide } from "../../services/UserGuideFileManager";
import { NotificationManager } from "react-notifications";
import { useMutation, useLazyQuery } from "@apollo/client";
import { clientWellness } from "../../App";

const HomWellness = () => {
  const [sendIceAlert] = useMutation(SEND_ICE_ALERT, {
    client: clientWellness,
  });
  const [showICE, setShowICE] = useState(false);
  const [selectMenu] = useState(["AboutWellness"]);
  const [index, setIndex] = useState(0);
  const [files, setFiles] = useState([]);
  const [, setshowLoader] = useState(false);
  const [runQueryGetResourceByModuleId] = useLazyQuery(
    RESOURCE_LIST_BY_MODULE,
    {
      fetchPolicy: "cache-and-network",
      onCompleted: (data) => {
        if (data?.resourceListByModule)
          setFiles([...data.resourceListByModule]);
      },
    }
  );

  useEffect(() => {
    runQueryGetResourceByModuleId({
      variables: {
        categoryName: selectMenu[0],
      },
      context: { clientName: "LinkUsers" },
    });
    setFiles([]);
  }, []);

  useEffect(() => {
    files.forEach((file) => {
      if (file.resourceName === "Agent User Guide") {
        console.log(file);
      }
    });
  }, [files]);

  const handleDownloadFile = () => {
    files.forEach((file) => {
      if (file.resourceName === "Agent User Guide") {
        getUserGuide(file.fileName);
      }
    });
  };

  let handleSendIceAlert = () => {
    setshowLoader(true);
    sendIceAlert()
      .then((res) => {
        if (res.data.sendIceAlert) {
          NotificationManager.success("The notification is sent", "", 5000);
        }
        setshowLoader(false);
      })
      .catch((error) => {
        setshowLoader(false);

        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
      });
  };

  const handleSelect = (selectedIndex, e) => {
    setIndex(selectedIndex);
  };

  const interval = 3000;

  return (
    <>
      <Carousel1>
        <Carousel
          controls={false}
          activeIndex={index}
          onSelect={handleSelect}
          interval={interval}
          pause={false}
        >
          <Carousel.Item>
            <img
              src={Carouselimage1}
              alt="First slide"
              style={{ borderRadius: "8px" }}
            />
            <Carousel.Caption>
              <CarouselItem>
                <div className="text1">About Wellness</div>
              </CarouselItem>
              <Button onClick={() => handleDownloadFile()}>
                <span className="button">Download</span>
              </Button>
            </Carousel.Caption>
          </Carousel.Item>

          <Carousel.Item style={{ borderRadius: "8px" }}>
            <div style={{ borderRadius: "8px" }}>
              <div className="custom-image-wrapper">
                <img src={Carouselimage2} alt="First slide" />
              </div>
              <Carousel.Caption>
                <CarouselItem2>
                  <div className="text1">Do you need emotional support?</div>
                  <div className="text2">
                    Remember that you can press the help button for a
                    professional to contact you
                  </div>
                </CarouselItem2>
                <CircleButton>
                  <Circle />
                  <HelpButton></HelpButton>
                </CircleButton>
              </Carousel.Caption>
            </div>
          </Carousel.Item>
        </Carousel>
      </Carousel1>
      {showICE && (
        <ModalConfirm
          info={`This request is for IMMEDIATE help from your wellness team. Are you sure to send it?`}
          handleConfirm={handleSendIceAlert}
          setModalVisibility={setShowICE}
          showCancel={true}
          modalTitle="Quick Assist"
        />
      )}
    </>
  );
};

export default HomWellness;
